module.exports = require('./lib');


//////////////////
// WEBPACK FOOTER
// ./~/sntp/index.js
// module id = 106
// module chunks = 0 1